import React, { useState } from "react";
import zoomSdk from "@zoom/appssdk";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import CryptoJS from "crypto-js";
import { SALT_KEY, ZOOM_SDB_API } from "../utility/constants";
import AlertMsg from "./Alert";
import FooterSecuredBy from "./footerSecuredBy";

const PublishForm = (props) => {
  const [formpublished, setFormPublished] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [invitationerror, setInvitationError] = useState(false);
  const recordindex = useSelector(
    (state) => state?.donation?.useraccountinfo || {}
  );

  const formSettings = useSelector(
    (state) => state?.donation?.formSettings || {}
  );
  const navigate = useNavigate();

  const publish = async (e) => {
    e.preventDefault();
    setShowLoader(true);

    let publishData = {
      eId: props.meetingData.meetingUUID,
      Id: recordindex.recordId,
    };
    let postBody = CryptoJS.AES.encrypt(
      JSON.stringify({ body: { publishData } }),
      SALT_KEY
    ).toString();
    axios
      .post(`${ZOOM_SDB_API}/publishform`, {
        httpMethod: "POST",
        path: "/publishform",
        postBody,
      })
      .then(async (res) => {
        if (res.data.body) {
           await zoomSdk.sendAppInvitationToAllParticipants();
          
          setFormPublished(true);
          navigate("/loadform",{ state: { showDForm: true } });
          setShowLoader(false);
        }
      })
      .catch((err) => {
     
        if(err.toString().indexOf('denied') > -1){
          setFormPublished(true);
          navigate("/loadform", { state: { showDForm: true } });
          setShowLoader(false);
        }else{
          setFormPublished(true);
          setInvitationError(true);
          setShowLoader(false);
        }
       
        
      });
  };

  const reLoad = () => {
    navigate('/loadform', { state: { showDForm: true } })
  }
 
  return (
    <>
      <div className="recurring_transaction_container">
        <div className="recurring_transaction_wrapper">
          <div className="recurring_transaction_card">
            <div className="recurring_transaction_card_header">
              <div className="transaction_info_logo_container">
             
                {!formSettings.FormHeader ? (
                        <img src={`images/givent_logo_1.png?${(new Date()).getTime()}`} alt="Click and Pledge" />
                      ):(
                        <div className="header-name">{formSettings.FormHeader}</div>
                      )}
              </div>

              {formpublished && !invitationerror && (
                <AlertMsg
                  message="Form Published Successfully! Please wait your form is loading..."
                  type="success"
                  isClose={true}
                />
              )}
              {invitationerror && (
                <>
                 <AlertMsg
                 message="Send Invitation timeout! Please reload your app again."
                 type="failure"
                 isClose={true}
               />
               <p onClick={reLoad} style={{color:'blue', cursor:'pointer'}}>Reload</p>
               </>
              )}
              {showLoader && (
                <div className="loader-container">
                 <div className="lds-ellipsis">
                 <div></div>
                 <div></div>
                 <div></div>
                 <div></div>
               </div>
               </div>
              )}
           
            </div>
            <div className="recurring_transaction_card_body">
             
              <div className="form_input_wrapper d-flex justify-content-between mt_1">
                <button
                  className="full_button tabindex_btn next"
                  type="button"
                  data-index="0"
                  onClick={publish}
                  disabled={formpublished}
                  style={{marginBottom:'20px'}}
                >
                  {!showLoader ? (
                    <>
                      <span className="">Publish & Broadcast</span>
                    </>
                  ) : (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span className="">Loading...</span>{" "}
                    </>
                  )}
                </button>
              </div>
            </div>
            <FooterSecuredBy />
          </div>
        </div>
      </div>
    </>
  );
};

export default PublishForm;
